import Vue from 'vue'
import Vuex from 'vuex'
import $router from '@/router/index'
import { queryButtonResourceList, getTenantInName } from '@/api/index'
Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    isM: false,
    isMobile: false,
    btnPower: window.localStorage.getItem('btnCode') ? JSON.parse(window.localStorage.getItem('btnCode')) : [],
    userInfo: window.localStorage.getItem('userInfo') ? JSON.parse(window.localStorage.getItem('userInfo')) : {},
    menusList: window.localStorage.getItem('menusList') ? JSON.parse(window.localStorage.getItem('menusList')) : [],
    tagList: window.localStorage.getItem('tagList') ? JSON.parse(window.localStorage.getItem('tagList')) : []
  },
  mutations: {
    setMobile(state, isMobile) {
      state.isMobile = isMobile
    },
  },
  actions: {
    login({ state }, res) {
      return new Promise(async resolve => {
        window.localStorage.clear()
        state.tagList = []
        window.localStorage.setItem('token', res.token)
        window.localStorage.setItem('menusList', JSON.stringify(res.resourceList || []))
        state.menusList = res.resourceList || []
        // 获取按钮级权限
        let btnResource = await queryButtonResourceList()
        let btnCode = btnResource.map(item => item.code)
        window.localStorage.setItem('btnCode', JSON.stringify(btnCode))
        state.btnPower = btnCode
        Vue.prototype.$bp = btnCode
        let res2 = await getTenantInName()
        res.userInfo.organizationName = res2.organizationName
        state.userInfo = res.userInfo
        window.localStorage.setItem('userInfo', JSON.stringify(res.userInfo))
        resolve()
      })
    },
    logout({ state }) {
      state.userInfo = {}
      state.menusList = []
      window.localStorage.clear()
      $router.push('/login')
    },
    closeRoute({ state }, fullPath) {
      let index = state.tagList.findIndex(item => item.fullPath === fullPath)
      state.tagList.splice(index, 1)
    },
    pushTagList({ state }, item) {
      let { meta, path, fullPath, query, name } = item
      let maxLength = state.isMobile ? 4 : 20
      state.tagList.push({
        meta, path, fullPath, query, name
      })
      if (state.tagList.length > maxLength) {
        state.tagList.shift()
      }
    },
    clearTag({ state }) {
      state.tagList = []
    },
    clearTagRight({ state }, index) {
      state.tagList.splice(index + 1, 9999)
    },
    clearTagOther({ state }, fullPath) {
      state.tagList = state.tagList.filter(ite => ite.fullPath === fullPath)
    }
  },
  getters: {
    isMobile: state => state.isMobile,
    userInfo: state => state.userInfo,
    btnPower: state => state.btnPower,
    menusList: state => {
      return state.menusList || []
    },
    tagList: state => {
      return state.tagList || []
    },
    getMenuPower: state => {
      // 系统自带路由
      let urls = ['/home', '/login', '/qrCode', '/traceDetail', '/downloadCenter', '/helpCenter', '/updateLog', '/workbench']
      let _find = list => {
        list.forEach(item => {
          if (item.url) {
            urls.push(item.url)
          }
          if (item.childResourceList && item.childResourceList.length) {
            _find(item.childResourceList)
          }
        })
      }
      if (state.menusList && state.menusList.length) {
        _find(state.menusList)
      }
      return urls
    }
  }
})
